import AdminEmailCampaignToken from '@apps/truevail/admin/tokens/admin_email_campaign'
import FoldersUpdateBatch from '@apps/truevail/admin/components/folders_update_batch'
import TagsUpdateBatch from '@apps/truevail/admin/components/tags_update_batch'
import LibraryAddBatch from '@apps/truevail/admin/components/library_add_batch'
import EmailCampaignCard from '@apps/truevail/admin/cards/email_campaign'
import LibraryAdd from '@apps/truevail/admin/components/library_add'
import LibraryToken from '@apps/truevail/admin/tokens/library'
import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import Clone from './clone'
import React from 'react'
import New from './new'

const mapPropsToPanel = (props, context) => ({
  title: 't(Email Campaigns)',
  collection: {
    endpoint: '/api/admin/truevail/admin/email_campaigns',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Email Campaign)', key: 'title', primary: true, format: (email_campaign) => (
        <AdminEmailCampaignToken email_campaign={ email_campaign } />
      ) },
      { label: 't(Variants)', key: 'variants_count', collapsing: true, align: 'right' },
      { label: 't(Publishings)', key: 'publishings_count', collapsing: true, align: 'right' },
      { label: 't(Library)', key: 'library_status', sort: 'status', collapsing: true, align: 'center', format: LibraryToken }
    ],
    card: (email_campaign) => (
      <EmailCampaignCard email_campaign={ email_campaign } />
    ),
    criteria: {
      fields: [
        {
          label: 't(Fields)',
          fields: [
            { name: 't(Perspective)', key: 'perspective', type: 'select', multiple: true, options: ['first-person singular','first-person plural'] },
            { name: 't(Language)', key: 'language', type: 'select', multiple: true, options: ['american english','canadian english','french','german','italian'] },
            { name: 't(Library)', key: 'status', type: 'select', multiple: true, options: ['draft','published'], format: StatusToken }
          ]
        }
      ]
    },
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'mail',
      title: 't(No Email Campaigns)',
      text: 't(You have not yet created any emails)',
      buttons: [
        { 
          label: 't(Create Email Campaign)', 
          modal: New 
        }
      ]
    },
    entity: 'email campaign',
    selectable: true,
    batch: {
      batch_type: 'truevail_email_campaigns',
      tasks: [
        { 
          label: 't(Add to Library)', 
          svg: 'book_plus',
          action: 'publish', 
          component: <LibraryAddBatch entity="admin" /> 
        },
        { 
          label: 't(Remove from Library)', 
          svg: 'book_minus',
          action: 'unpublish', 
          config: { entity: 'admin' } 
        },
        { 
          label: 't(Update Folders)',
          svg: 'folder',
          action: 'folder', 
          component: <FoldersUpdateBatch entity="admin" />  
        },
        { 
          label: 't(Update Tags)',
          svg: 'tags',
          action: 'tag', 
          component: <TagsUpdateBatch entity="admin" />  
        }
      ]
    },
    recordTasks: (record) => [
      {
        label: 't(Duplicate Email Campaign)',
        svg: 'copy',
        modal: <Clone email_campaign={ record } />
      },
      {
        label: 't(Add to Library)',
        svg: 'book_plus',
        show: record.status === 'draft',
        modal: <LibraryAdd scope="admin" entity="email_campaigns" record={ record } />
      },
      {
        label: 't(Remove from Library)',
        svg: 'book_minus',
        show: record.status === 'published',
        request: {
          endpoint: `/api/admin/truevail/admin/email_campaigns/${record.id}/unpublish`,
          method: 'PATCH',
          onSuccess: () => context.flash.set('success', 't(Successfully removed this email campaign from the library)'),
          onFailure: () => context.flash.set('error', 't(Unable to remove this email campaign from the library)')
        }
      },
      {
        label: 't(Delete Email Campaign)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this campaign?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/email_campaigns/${record.id}`,
          method: 'DELETE',
          onSuccess: () => context.flash.set('success', 't(Successfully deleted campaign)'),
          onFailure: () => context.flash.set('error', 't(Unable to delete campaign)')
        }
      }
    ],
    onClick: (record) => context.router.push(`/admin/truevail/admin/email_campaigns/${record.id}`)
  },
  task: {
    svg: 'plus',
    tooltip: 't(Create Email Campaign)', 
    modal: New
  }
})

export default Panel(null, mapPropsToPanel)
